var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subMenuWrapper",style:(_vm.isSelected ? 'color: rgb(0,153,255);' : ''),on:{"click":_vm.goToSelectPage}},[_c('img',{staticClass:"iconImg",attrs:{"src":_vm.iconImg}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.spanText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61458ebe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/elements/subMenu.vue
// module id = null
// module chunks = 